export const CONNECTION_TYPES = [
  "videohub",
  "atem",
  "behringer_wing",
  "dlive",
  "companion",
  "generic",
] as const;

export type ConnectionType = (typeof CONNECTION_TYPES)[number];

export const CONNECTION_TYPE_LABELS: Record<ConnectionType, string> = {
  videohub: "Blackmagic VideoHub",
  atem: "ATEM Mixer",
  behringer_wing: "Behringer Wing",
  dlive: "Allen & Heath dLive",
  companion: "Bitfocus Companion",
  generic: "Generic Device",
};

export const DEFAULT_PORTS: Record<ConnectionType, number> = {
  videohub: 9990,
  atem: 9910,
  behringer_wing: 2222,
  dlive: 51325,
  companion: 8000,
  generic: 80,
};
